import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExternalLinkIcon } from '@chakra-ui/icons';
const CustomButton = ({ openPopup, webAuthURL, text }) => {
    // Styling for the button
    const buttonStyle = {
        marginTop: '68px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px 15px',
        backgroundColor: 'white',
        color: 'black',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
    };
    const iconStyle = {
        marginLeft: '8px',
    };
    return (_jsxs("button", { style: buttonStyle, onClick: () => openPopup(webAuthURL), children: [text, _jsx(ExternalLinkIcon, { style: iconStyle })] }));
};
export default CustomButton;
